import { render, staticRenderFns } from "./ActionShowContacts.vue?vue&type=template&id=5d7a1453"
import script from "./ActionShowContacts.vue?vue&type=script&lang=js"
export * from "./ActionShowContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports